
import {getViewExchangeRates} from '../api/getViewExchangeRates';
import {setGetViewExchangeRatesAction} from '../action';

const setGetViewExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewExchangeRates(params);
            if (data.status === 'success') {
                dispatch(setGetViewExchangeRatesAction({
                    id: data.data.id,
                    to_currency: data.data.to_currency,
                    from_currency: data.data.from_currency,
                    value: data.data.value
                }));       
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewExchangeRates
}